import BaseNodeModel from "../BaseNodeModel";
import ReactDOM from "react-dom";
import CustomQueryDialog from "../../widgets/dialogs/CustomQueryDialog";

export default class DataNodeModel extends BaseNodeModel {
    /**
     * Data access node model
     * @module DataNodeModel
     * @param {string} nodeName Node display name
     * @param {number} x Node x coordinate on canvas
     * @param {number} y Node y coordinate on canvas
     * @param {Object} props Pre-defined node properties; if non-null, apply values to node properties
     * @param {string} id If non-null, use this ID as the node ID
     */
    constructor(nodeName = "UNTITLED_NODE", x = 0, y = 0, props = null, id = null) {
        super(nodeName, x, y, null, id);
        this.props.nodeTypeName = "Data Access";
        this.props.colorClass = "yellow";
        this.props.iconClass = "server";
        this.DEFAULT_COLOR_CLASS = "yellow";
        this.applyProps(props);
    }
    setConfig(key, value) {
        
        super.setConfig(key, value);
        
        if (key === "asynchronous") {
            // Refresh property panel when changing what function the node is using
            document.dispatchEvent(new CustomEvent("ev-property-refresh"));
        }

        this.props.lastLocalChange = window.apm.timestamp;
    
    }

    getConfig(key) {
        
        // customScript is the key for Data Access Node scripts. Script is for Queries/Mutations
        if (key === "customScript") {
            return this.props.config.customScript ? this.props.config.customScript : "";
        }

        return super.getConfig(key);
    }

   getConfigViews() {
        const addButton = this.props.isCommonModule === true ? "" : '<button class="w2ui-btn primary add-button">' + window.l.popup.save + '</button>';
        const schemaLabel = this.props.isCommonModule === true ? "View Query / Mutation": this.getPropLabel("schema_script");
        this.props.configView = [];

        if(!this.props.config.asynchronous){
            this.props.configView.push({type: "ItemList", label: this.getPropLabel("outputs"), key: "outputs", view: "return"});
        }
        this.props.configView.push(
            {type: "Switch", key: "asynchronous", label: this.getPropLabel("async"), checked: false, broadcast: true },
            {type: "hr"},
            {type: "Button", label: schemaLabel, key: "variables", wide: true, callback: (event, buttonDom, context) => {
                    window.apm.popup(window.l.popup.query_mutation,
                    '<div class="custom_script_container"></div>',
                        '<button class="w2ui-btn secondary" onclick="w2popup.close();">' + window.l.popup.close + '</button> ' +
                        addButton,
                    [
                        ".custom_script_container",

                        () => {
                            ReactDOM.render(<CustomQueryDialog
                                context={this}/>, $(".custom_script_container").get(0));
                            if(!this.props.isCommonModule){
                                $(".w2ui-popup").find(".add-button").on("click", () => {
                                document.dispatchEvent(new CustomEvent("ev-dialog-add"));
                                window.apm.updateParentNode(context,context.props.parentComponentID, "script",context.props.config.script, context.type);
                              });
                            }
                        
                        }
                    ]
                        
                );
            }}
           
        );
        if (!this.props.config.asynchronous) {
            this.props.configView.push( {type: "Function", hideKey: "asynchronous",key: "customScript",functionType: "CUSTOM"},  )
        }

        return [
            ...this.getConfigViewNameField(),
            ...[
                {type: "Textarea", label: this.getPropLabel("description"), key: "description"},
                {type: "Input", label: "HTTP Request Timeout", key: "httpRequestTimeout", tooltip: this.getPropLabel("http_request_timeout_tooltip"), hint: this.getPropLabel("http_request_timeout_hint"), suggestion: "variable", valRules: {"numberOrVariableRef": true }},
                {type: "ItemList", label: this.getPropLabel("inputs"), key: "inputs", view: "argument"},
                {type: "ItemList", label: "Custom HTTP Headers", key: "headers", view: "customHeader"}
            ],
            ...this.props.configView,
           
            ...[
                {type: "hr"},
                {type: "Textarea", label: this.getPropLabel("note"), key: "note"}
            ]
        ];
    }
}